module.exports = __webpack_public_path__ + "img/rio-zacate.68b1e4a8.jpg";